import Transform from "./Transform.js";
import Indicator from "./Indicator.js";

import uuid from "../../library/uuid.js";

import Style from "../utils/Style.js";

import global from "../global.js";

const d3 = global.d3;

// const log = global.log.getLogger("f_mtac.scene.placeholder");

const Placeholder = function(group, type, draggable, data) {
    const indicator = new Indicator(group);
    this.position = {x: 0, y: 0};
    this.placeholder = d3.select(global.resources.category["_placeholder"][type].cloneNode(true)).attr("transform", null);
    this.handle = d3.create("svg:g").attr("class", "handle").attr("id", uuid());
    this.node = this.handle.append("g").attr("class", `node placeholder placeholder-${type}`);
    this.node.node().appendChild(this.placeholder.node());

    Object.defineProperty(this, "indicator_position", {
        set: () => {},
        get: () => indicator.position
    });

    if (draggable !== undefined) {
        let drag = d3.drag();
        drag.on("start", () => {
            draggable.start(data, this);
        });
        drag.on("drag", () => {
            draggable.drag(data, this);
        });
        drag.on("end", () => {
            draggable.end(data, this);
        });
        drag(this.handle);
    }

    this.init = ({color}) => {
        if (color === undefined) {
            color = "#000";
        }
        this.end();
        group.node().appendChild(this.handle.node());
        indicator.init({color});
    };

    this.move_to = function({x, y}) {
        this.position.x = x;
        this.position.y = y;
        this.handle.attr("transform", `translate(${this.position.x},${this.position.y})`);
        indicator.move_to({x, y});
    };

    this.move = function({x, y}) {
        this.position.x += x;
        this.position.y += y;
        this.handle.attr("transform", `translate(${this.position.x},${this.position.y})`);
        indicator.move({x, y});
    };

    this.end = () => {
        this.handle.remove();
        indicator.end();
    };
};

const style = new Style();
Placeholder.transform = new Transform({k: 1});
Placeholder.transform.on_scale(({k}) => {
    style.rule_set("scene_placeholder_scale", `.placeholder > g { transform-origin: 100px 100px; transform: scale(calc((var(--kb) * 96) / 150 * ${1 / k})); }`);
});

export default Placeholder;
